module.exports = __webpack_public_path__ + "img/1557614068440834050.7e4de0dd.png";